import { createTypes } from './createTypes';

export default createTypes(
  'GET_BALANCES',
  'GET_WALLET',
  'GET_INVOICES',
  'SYNC_UPDATE_API_PREFIX'
);
